import React from "react";
import klarnaIcon from "@/public/icons/klarna_pink.svg";
import s from "@/components/Buttons/klarnaButton.module.scss";

const KlarnaExpressButton = ({ handleClick }) => {
  return (
    <button className={s["klarnaButton"]} type="submit" onClick={handleClick}>
      <span>Pay With</span>
      <img src={klarnaIcon} alt="klarna icon" width="77" height="32" />
    </button>
  );
};

export default KlarnaExpressButton;
